import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/components/ui/TextField';

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const EmailClientForm = ({ value, name, setValue, ...rest }) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (value && setValue) {
            setValue(name, value, { shouldValidate: true });
        }
    }, [value, name, setValue]);

    return (
        <TextField
            {...rest}
            name={name}
            value={value}
            variant="email"
            inputMode="email"
            autoComplete="email"
            rules={{
                pattern: {
                    value: EMAIL_PATTERN,
                    message: t('form.pleaseEnterValidEmail'),
                },
            }}
        />
    );
};

export default EmailClientForm;
